import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import registerImg from "../../icons/registerImg.svg";
import "./style.scss";
import ImageUpload from "../../CoreComponent/ImageUpload";
import axios from "axios";
import DialogMessage from "../../components/DialogMessage";
import {
  Button,
  Container,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  TextField,
  Typography,
  Select,
  MenuItem,
} from "@mui/material";
import { darken } from "@mui/system";
import PhoneInput from "react-phone-input-2";

const RegisterPage = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();
  const API_BASE = "https://eventscons.com/eventbackendnew/api";

  const [name, setName] = useState("");
  const [title, setTitle] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [whatsApp, setWhatsApp] = useState("");
  const [specialization, setSpecialization] = useState("");
  const [selectedNationality, setSelectedNationality] = useState("India");
  const [country, setCountry] = useState("UAE");
  const [companyName, setCompanyName] = useState("TechZenon");
  const [contactPerson, setContactPerson] = useState("jane Doe");
  const [companyAddress, setCompanyAddress] = useState("Dubai, UAE");
  const [image, setImage] = useState(null);
  const [resumeText, setResumeText] = useState("");

  const [formData, setFormData] = useState({
    accept_cancellation_policy: false,
  });

  // ✅ Countries dropdown state
  const [countries, setCountries] = useState([]);
  const [loadingCountries, setLoadingCountries] = useState(false);

  const [error, setError] = useState({
    name: "",
    title: "",
    email: "",
    password: "",
    phone: "",
    whatsApp: "",
    specialization: "",
    nationality: "",
    country: "",
    companyName: "",
    contactPerson: "",
    companyAddress: "",
    image: "",
    resume: "",
  });

  // ✅ fetch countries (same API as other page)
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        setLoadingCountries(true);
        const res = await axios.get(`${API_BASE}/countries`, {
          headers: { Accept: "application/json" },
        });
        const list = res.data?.data || [];
        setCountries(list);

        // optional: if current country not in list, set first
        if (list.length && !list.some((c) => c.name === country)) {
          setCountry(list[0].name);
        }
      } catch (e) {
        console.error("Countries API error:", e);
        toast.error("Failed to load countries.");
      } finally {
        setLoadingCountries(false);
      }
    };

    fetchCountries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = async () => {
    if (!formData.accept_cancellation_policy) {
      toast.error("Please accept the cancellation and refund policy.");
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("name", name);
    formDataToSend.append("title", title);
    formDataToSend.append("email", email);
    formDataToSend.append("password", password);
    formDataToSend.append("image", image);
    formDataToSend.append("biography", resumeText);
    formDataToSend.append("registration_type", "speaker");
    formDataToSend.append("phone_number", phone ? `+${phone}` : "");
    formDataToSend.append("whatsapp_number", whatsApp ? `+${whatsApp}` : "");
    formDataToSend.append("specialization", specialization);
    formDataToSend.append("nationality", selectedNationality);
    formDataToSend.append("country_of_residence", country); // ✅ dropdown value (country name)
    formDataToSend.append("isAdmin", "false");
    formDataToSend.append("company_name", companyName);
    formDataToSend.append("contact_person", contactPerson);
    formDataToSend.append("company_address", companyAddress);
    formDataToSend.append("conference_id", id);

    try {
      setLoading(true);
      const url = `${API_BASE}/speakerusers`;
      await axios.post(url, formDataToSend, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setLoading(false);
      setIsDialogOpen(true);
      toast.success("Registration successful!");
    } catch (error) {
      setLoading(false);
      console.error("Error during registration:", error.response?.data || error);
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Registration failed. Please check your details."
      );
    }
  };

  const handleRegister = (e) => {
    e.preventDefault();

    let errorName = "";
    let errorTitle = "";
    let errorEmail = "";
    let errorPassword = "";
    let errorPhone = "";
    let errorWhatsApp = "";
    let errorSpecialization = "";
    let errorNationality = "";
    let errorCountry = "";
    let errorCompanyName = "";
    let errorContactPerson = "";
    let errorCompanyAddress = "";
    let errorImage = "";
    let errorResume = "";

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!name) errorName = "Please enter your full name.";
    if (!title) errorTitle = "Please enter your title.";
    if (!email) errorEmail = "Please enter your email.";
    else if (!emailRegex.test(email)) errorEmail = "Invalid email format.";
    if (!password) errorPassword = "Please enter your password.";
    if (!phone) errorPhone = "Please enter your phone number.";
    if (!whatsApp) errorWhatsApp = "Please enter your WhatsApp number.";
    if (!specialization) errorSpecialization = "Please enter your specialization.";
    if (!selectedNationality) errorNationality = "Please enter your nationality.";
    if (!country) errorCountry = "Please select your country.";
    if (!companyName) errorCompanyName = "Please enter company name.";
    if (!contactPerson) errorContactPerson = "Please enter contact person.";
    if (!companyAddress) errorCompanyAddress = "Please enter company address.";
    if (!image) errorImage = "Please upload a profile picture.";
    else if (!["jpg", "jpeg", "png", "gif"].includes(image.type.split("/")[1]))
      errorImage = "Only image files (jpg, jpeg, png, gif) are allowed.";
    if (!resumeText) errorResume = "Please write your biography.";

    setError({
      name: errorName,
      title: errorTitle,
      email: errorEmail,
      password: errorPassword,
      phone: errorPhone,
      whatsApp: errorWhatsApp,
      specialization: errorSpecialization,
      nationality: errorNationality,
      country: errorCountry,
      companyName: errorCompanyName,
      contactPerson: errorContactPerson,
      companyAddress: errorCompanyAddress,
      image: errorImage,
      resume: errorResume,
    });

    if (
      name &&
      title &&
      email &&
      emailRegex.test(email) &&
      password &&
      phone &&
      whatsApp &&
      specialization &&
      selectedNationality &&
      country &&
      companyName &&
      contactPerson &&
      companyAddress &&
      !errorImage &&
      !errorResume
    ) {
      handleSubmit();
    }
  };

  return (
    <Container
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "15vh",
        marginBottom: "15vh",
      }}
    >
      <DialogMessage isDialogOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen} />

      <Grid container spacing={2}>
        {/* Left Side Form */}
        <Grid
          item
          xs={12}
          sm={6}
          sx={{
            order: { xs: 2, sm: 1 },
          }}
        >
          <form onSubmit={handleRegister}>
            <Grid container spacing={2}>
              {/* Header */}
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h4" sx={{ color: "#c62828" }}>
                  Register
                </Typography>
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "#9B1321",
                    "&:hover": { backgroundColor: darken("#dc143c", 0.2) },
                  }}
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              </Grid>

              {/* Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Full Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  error={!!error.name}
                  helperText={error.name}
                  fullWidth
                  placeholder="e.g. John Doe"
                />
              </Grid>

              {/* Title */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  error={!!error.title}
                  helperText={error.title}
                  fullWidth
                  placeholder="e.g. Mr., Ms., Dr., Prof."
                />
              </Grid>

              {/* Company Name */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Company Name"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  error={!!error.companyName}
                  helperText={error.companyName}
                  fullWidth
                  placeholder="e.g. TechZenon"
                />
              </Grid>

              {/* Contact Person */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Contact Person"
                  value={contactPerson}
                  onChange={(e) => setContactPerson(e.target.value)}
                  error={!!error.contactPerson}
                  helperText={error.contactPerson}
                  fullWidth
                  placeholder="e.g. Jane Doe"
                />
              </Grid>

              {/* Email */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={!!error.email}
                  helperText={error.email}
                  fullWidth
                  type="email"
                  placeholder="example@example.com"
                />
              </Grid>

              {/* Password */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  error={!!error.password}
                  helperText={error.password}
                  fullWidth
                  type="password"
                  placeholder="Enter password"
                />
              </Grid>

              {/* Phone */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel shrink>Phone Number</InputLabel>
                  <PhoneInput
                    country={"jo"}
                    value={phone}
                    onChange={setPhone}
                    inputStyle={{
                      width: "100%",
                      height: "56px",
                      borderColor: error.phone ? "red" : "#c4c4c4",
                      borderRadius: "4px",
                    }}
                    placeholder="Phone number"
                  />
                  {error.phone && (
                    <FormHelperText style={{ color: "red" }}>{error.phone}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* WhatsApp */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel shrink>WhatsApp Number</InputLabel>
                  <PhoneInput
                    country={"jo"}
                    value={whatsApp}
                    onChange={setWhatsApp}
                    inputStyle={{
                      width: "100%",
                      height: "56px",
                      borderColor: error.whatsApp ? "red" : "#c4c4c4",
                      borderRadius: "4px",
                    }}
                    placeholder="WhatsApp number"
                  />
                  {error.whatsApp && (
                    <FormHelperText style={{ color: "red" }}>{error.whatsApp}</FormHelperText>
                  )}
                </FormControl>
              </Grid>

              {/* Specialization */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Specialization"
                  value={specialization}
                  onChange={(e) => setSpecialization(e.target.value)}
                  error={!!error.specialization}
                  helperText={error.specialization}
                  fullWidth
                  placeholder="Your specialization"
                />
              </Grid>

              {/* Nationality */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Nationality"
                  value={selectedNationality}
                  onChange={(e) => setSelectedNationality(e.target.value)}
                  error={!!error.nationality}
                  helperText={error.nationality}
                  fullWidth
                  placeholder="e.g. Indian"
                />
              </Grid>

              {/* ✅ Country dropdown with flag + name */}
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth error={!!error.country}>
                  <InputLabel id="country-label">Country of Residence</InputLabel>
                  <Select
                    labelId="country-label"
                    label="Country of Residence"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    disabled={loadingCountries}
                  >
                    {countries.map((c) => (
                      <MenuItem key={c.id} value={c.name}>
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <img
                            src={c.flag_url}
                            alt={`${c.name} flag`}
                            width={22}
                            height={16}
                            style={{ borderRadius: 2, objectFit: "cover" }}
                            loading="lazy"
                          />
                          <span>{c.name}</span>
                        </div>
                      </MenuItem>
                    ))}
                  </Select>

                  {error.country && <FormHelperText>{error.country}</FormHelperText>}
                </FormControl>
              </Grid>

              {/* Company Address */}
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Company Address"
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  error={!!error.companyAddress}
                  helperText={error.companyAddress}
                  fullWidth
                  placeholder="e.g. Dubai, UAE"
                />
              </Grid>

              {/* Profile Image */}
              <Grid item xs={12}>
                <ImageUpload
                  label="Profile Picture"
                  required={true}
                  allowedExtensions={["jpg", "jpeg", "png", "gif"]}
                  inputValue={image}
                  setInputValue={setImage}
                  errorMsg={error.image}
                />
              </Grid>

              {/* Resume / Biography */}
              <Grid item xs={12}>
                <TextField
                  label="Biography"
                  value={resumeText}
                  onChange={(e) => setResumeText(e.target.value)}
                  error={!!error.resume}
                  helperText={error.resume}
                  fullWidth
                  multiline
                  rows={5}
                  placeholder="Write about yourself..."
                />
              </Grid>

              {/* Cancellation policy checkbox */}
              <Grid item xs={12}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 8 }}>
                  <input
                    type="checkbox"
                    name="accept_cancellation_policy"
                    checked={formData.accept_cancellation_policy}
                    onChange={(e) =>
                      setFormData((p) => ({
                        ...p,
                        accept_cancellation_policy: e.target.checked,
                      }))
                    }
                    required
                    style={{ marginTop: 3 }}
                  />
                  <span style={{ fontSize: 14, lineHeight: 1.4 }}>
                    I agree to the{" "}
                    <a
                      href="/cancellation-and-refund-policy"
                      style={{ fontWeight: "700", textDecoration: "underline" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Cancellation and Refund Policy
                    </a>
                    . I confirm that I have read and accepted the terms in case of cancellation or
                    no-show. Link to{" "}
                    <a
                      href="/terms-and-conditions"
                      style={{ fontWeight: "700", textDecoration: "underline" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      terms and conditions
                    </a>
                    .
                  </span>
                </div>
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "right" }}>
                <Button
                  type="submit"
                  disabled={loading}
                  sx={{
                    backgroundColor: "#9B1321",
                    "&:hover": { backgroundColor: darken("#dc143c", 0.2) },
                    color: "white",
                    width: { xs: "100%", sm: "100%", md: "50%" },
                  }}
                >
                  {loading ? "Submitting..." : "Register"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Grid>

        {/* Right Side Image */}
        <Grid item xs={12} sm={6} sx={{ order: { xs: 1, sm: 2 } }}>
          <img
            src={registerImg}
            alt="register"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default RegisterPage;
